import request from '@/utils/request'
import {
  InventoryHistoryReqParams,
  InventoryHistoryItem,
  InventoryDefectHistoryReqParams,
  InventoryDefectHistoryItem,
  InventoryHistoryDetailReqParams,
  InventoryHistoryDetailItem,
  InventoryDefectHistoryDetailReqParams,
  InventoryDefectHistoryDetailItem,
} from '@/services/inventory/inventory.types'

// IV02 재고수불내역 (LOGISPRD-13946). 서버 페이징 없이 전건을 받고, 결과가 없으면 빈 배열이다.
export const INVENTORY_HISTORY_URL = '/api/v1/inventory/monthly-reports'
export const INVENTORY_HISTORY_EXCEL_URL = `${INVENTORY_HISTORY_URL}/excel`
export const INVENTORY_HISTORY_DETAIL_URL = `${INVENTORY_HISTORY_URL}/items`
export const INVENTORY_HISTORY_DETAIL_EXCEL_URL = `${INVENTORY_HISTORY_DETAIL_URL}/excel`

/** 폼의 마감월 [시작, 끝]을 BE 범위 파라미터(양끝 포함)로 푼다. 조회와 엑셀이 같은 조건을 쓴다. */
export const toInventoryHistoryQuery = ({ sprNm, clsMonthM: [clsMonthFrom, clsMonthTo] }: InventoryHistoryReqParams) => ({
  sprNm,
  clsMonthFrom,
  clsMonthTo,
})

export const getInventoryHistory = (params: InventoryHistoryReqParams) =>
  request.get<ApiResponseV2<{ items: InventoryHistoryItem[] }>>(INVENTORY_HISTORY_URL, toInventoryHistoryQuery(params))

export const getInventoryHistoryDetail = (params: InventoryHistoryDetailReqParams) =>
  request.get<ApiResponseV2<{ items: InventoryHistoryDetailItem[] }>, InventoryHistoryDetailReqParams>(INVENTORY_HISTORY_DETAIL_URL, params)

// IV03 불량수불내역 (LOGISPRD-14028). IV02 와 같은 조건·응답이고 경로만 다르다.
export const INVENTORY_DEFECT_HISTORY_URL = '/api/v1/inventory/defect-reports'
export const INVENTORY_DEFECT_HISTORY_EXCEL_URL = `${INVENTORY_DEFECT_HISTORY_URL}/excel`
export const INVENTORY_DEFECT_HISTORY_DETAIL_URL = `${INVENTORY_DEFECT_HISTORY_URL}/items`
export const INVENTORY_DEFECT_HISTORY_DETAIL_EXCEL_URL = `${INVENTORY_DEFECT_HISTORY_DETAIL_URL}/excel`

export const getInventoryDefectHistory = (params: InventoryDefectHistoryReqParams) =>
  request.get<ApiResponseV2<{ items: InventoryDefectHistoryItem[] }>>(INVENTORY_DEFECT_HISTORY_URL, toInventoryHistoryQuery(params))

export const getInventoryDefectHistoryDetail = (params: InventoryDefectHistoryDetailReqParams) =>
  request.get<ApiResponseV2<{ items: InventoryDefectHistoryDetailItem[] }>, InventoryDefectHistoryDetailReqParams>(
    INVENTORY_DEFECT_HISTORY_DETAIL_URL,
    params,
  )
